<template>
  <div class="physiquePage">
    <div class="physique">
      <div class="physique-img">
        <left style="color: #ffffff"></left>
      </div>
    </div>
    <div class="chart_box">
      <div class="chart_top">
        <div class="chart_top_l">运动量记录曲线</div>
        <div class="chart_top_r" @click="show = true">{{ start_date }} 至 {{ end_date }}</div>
      </div>
      <Echart :options="option" id="huanChart" height="233px" width="100%" />
    </div>
    <!--    ========-->
    <div class="info-box">
      <div class="info-title">
        <img src="../assets/imgs/title_img@2x.png" alt="" />
        <div class="info-title-txt">数据记录</div>
      </div>
      <van-list v-model="loading" @load="getSportDateList">
        <div class="info-box-items" style="display: flex" v-for="(item, index) in sportList" :key="index">
          <div class="items-dian"></div>
          <div class="item-w" style="display: flex; flex-direction: column">
            <div class="item-date">{{ item.date }}</div>
            <div class="item-box">
              <div style="display: flex; justify-content: space-between">
                <div class="BMI-font">热量消耗:{{ Number(item.total_calorie).toFixed(2) }}千卡</div>
                <div style="display: flex; align-items: center" class="mg">
                  <img src="../assets/imgs/体格-icon@2x.png" />
                  <div class="BMI-icon" @click="goEditSports(item.date, item.total_calorie)">修改</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-calendar
      v-model="show"
      type="range"
      @confirm="onConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      :max-range="30"
      :default-date="choseDate"
    />
    <div class="info-btn" @click="goEditSports(date, sportList[0].total_calorie)">记录今天的运动</div>
  </div>
</template>

<script>
import { sportDateList, ydqx, getUserHealth } from "../service/api";
import { Dialog } from "vant";
import left from "../components/arrow-left";
import Echart from "@/common/echart";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "sport",
  components: {
    left,
    Echart,
  },
  created() {
    this.userHealth()

    this.d = this.dayjs().format("DD");
    this.m = this.dayjs().format("MM");
    this.y = this.dayjs().format("YYYY");
    this.date = this.y + "-" + this.m + "-" + this.d;

    // 前七天
    this.start_date = this.getBeforeDate(7);
    // 当天
    this.end_date = this.y + "-" + this.m + "-" + this.d;
    this.choseDate[0] = new Date(this.start_date);
    this.choseDate[1] = new Date(this.end_date);
    this.goChoseName = "热量消耗";
    this.goChose();
  },
  data() {
    return {
      date: "",
      loading: false,
      sportList: [],
      page: 1,
      limit: 10,

      show: false,
      option: {}, // 折线图
      isChose: 1, // 图表选中
      danwei: "",
      dataY: [], // Y轴数据
      dataX: [], // X轴数据
      start_date: "", // 开始时间
      end_date: "", // 结束时间
      choseDate: [],
      minDate: new Date(1900, 1, 1, 0, 0, 0),
    };
  },
  methods: {
    userHealth() {
      getUserHealth()
        .then((res) => {
          if (res.data.age_error_msg) {
            Dialog.alert({
                message: '运动记录仅限于年龄5~18岁的儿童',
              }).then(() => {
              });
          }
        })
        .catch((err) => {
          // this.$toast('请先完成登录',err)
        });
    },
    // 时间格式化
    getBeforeDate(time) {
      var n = time;
      var d = new Date();
      var year = d.getFullYear();
      var mon = d.getMonth() + 1;
      var day = d.getDate();
      if (day <= n) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - n);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s = year + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);
      return s;
    },
    // 日期格式
    formatDate(date) {
      let year = date.getFullYear();
      let mon = date.getMonth() + 1;
      let day = date.getDate();
      let s = year + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);
      return s;
    },
    // 日期选择
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.start_date = this.formatDate(start);
      this.end_date = this.formatDate(end);
      this.goChose();
    },
    // 折线图选中
    goChose() {
      let params = {
        start_date: this.start_date,
        end_date: this.end_date,
      };
      ydqx(params)
        .then((res) => {
          console.log("折线图选中", res);
          this.dataX = res.data.x;
          this.dataY = res.data.y;
          this.danwei = res.data.unit;
          this.changeChart();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goEditSports(date) {
      // this.$router.push({ path: "/editsports", query: { date: date } });
      this.$router.push({ path: "/sportChose", query: { date: date } });
    },
    // goEditSports(date,item_calorie){
    //   if (item_calorie == 0) {
    //     this.$router.push({path:'/editsports',query:{date:date}})
    //   }else {
    //     this.$router.push({path:'/hasRecord',query:{date:date,type:5}})
    //   }
    // },
    getSportDateList() {
      sportDateList({ page: this.page, limit: this.limit })
        .then((res) => {
          this.page += 1;
          console.log(res.data.list);
          this.sportList = [...this.sportList, ...res.data.list];
          this.loading = false;
          console.log(this.sportList[0].total_calorie, 123);
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // echart
    changeChart() {
      // 表格数据
      this.option = {
        tooltip: {
          trigger: "axis",
        },
        // 边距
        grid: {
          x: 40,
          y: 40,
          x2: 10,
          y2: 40,
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#333",
              },
            },
            axisLabel: {
              // X坐标轴刻度标签的相关设置。
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
              formatter: function (params) {
                let newParamsName = String(params); // 最终拼接成的字符串
                newParamsName = newParamsName.replace("-", "\n");
                //将最终的字符串返回
                return newParamsName;
              },
            },
            data: this.dataX,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "千卡",
            // y轴刻度线
            splitLine: {
              show: true,
            },
            // y轴文字颜色
            axisLabel: {
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            name: "运动量",
            smooth: true,
            data: this.dataY,
          },
        ],
      };
    },
  },
};
</script>

<style scoped lang="scss">
.physiquePage {
  width: 100%;
  height: 100%;
  .physique {
    width: 375px;
    height: 156px;
    background: url("../assets/imgs/运动-pic@2x.png");
    background-size: 100% auto;
    .physique-img {
      padding-top: 25px;
      margin-left: 16px;
    }
  }
  .chart_box {
    box-sizing: border-box;
    padding: 10px;
    .chart_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .chart_top_r {
        background: #f7f7f7;
        padding: 5px;
        font-size: 12px;
        color: #506b9c;
        border: 0.5px solid #eeeeee;
        border-radius: 4px;
      }
    }
  }
  .info-box {
    margin-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 100px;
    .info-title {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .info-title-txt {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .info-box-items {
      height: 88px;
      /*opacity: 0.2;*/
      border-left: 1px dashed #979797;
      .items-dian {
        opacity: 1;
        margin-left: -4px;
        width: 6px;
        height: 6px;
        background: #224a91;
        opacity: 1;
        border: 1px solid #ffffff;
        border-radius: 50%;
      }
      .item-w {
        width: 325px;
        margin-left: 18px;
        .item-date {
          margin-top: -5px;
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          /*line-height: 18px;*/
        }
        .item-box {
          margin-top: 10px;
          height: 56px;
          background: #f3f7fb;
          border-radius: 8px;
          padding-left: 12px;
          padding-right: 12px;
          .item-box-bottom {
            margin-top: 12px;
            display: flex;
            .font2 {
              margin-left: 80px;
            }
            .font {
              height: 18px;
              font-size: 13px;
              font-weight: 400;
              color: #333333;
              line-height: 18px;
            }
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
  .info-btn {
    position: fixed;
    bottom: 44px;
    left: 24px;
    width: 327px;
    height: 44px;
    background: #224a91;
    border-radius: 4px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #fefffe;
    line-height: 44px;
  }
  .mg {
    margin-top: 17px;
  }
  .BMI-font {
    margin-top: 17px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 22px;
  }
  .BMI-icon {
    /*margin-top: 17px;*/
    margin-left: 2px;
    font-size: 13px;
    font-weight: 400;
    text-align: right;
    color: #224a91;
    line-height: 20px;
  }
}
</style>
